import { ImageUpload } from "components/imageUpload";
import InnerInput from "components/inputs/InnerInput/InnerInput";
import { useTranslation } from "react-i18next";

import styles from "./CmsFooterPartnersCard.module.scss";
import { ReactComponent as DeleteIcon } from "assets/icons/bin-icon.svg";
import cn from "clsx";

type Props = {
  id: number | string;
  alt: string;
  link: string;
  image: string | File;
  onChangeLink: (e: string) => void;
  onChangeAlt: (e: string) => void;
  onAddImage?: (e: File) => void;
  onDeleteBannerCard?: () => void;
  isDeleting?: boolean;
  isActive: boolean;
  fieldErrors?: Record<string, string>;
  clearFieldError: (field: string) => void;
  readOnly?: boolean;
};

export const CmsFooterPartnersBannerCard: React.FC<Props> = ({
  id,
  alt,
  link,
  image,
  onChangeLink,
  onChangeAlt,
  onAddImage,
  onDeleteBannerCard,
  isDeleting = false,
  isActive,
  fieldErrors,
  readOnly
}) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        styles.cmsPartnersCard,
        isDeleting && styles.cmsPartnersCardLoading,
      )}
    >
      <div className={styles.cmsPartnersCardImage}>
        <ImageUpload
          image={image}
          className={styles.cmsPartnersCardImageUpload}
          onAddImage={onAddImage}
          isActive={isActive}
          hasError={Boolean(fieldErrors?.["files"])}
          disabled={readOnly}
        />
      </div>
      <div className={styles.cmsPartnersCardInfo}>
        <div className={styles.cmsPartnersCardAlt}>
          <InnerInput
            value={alt}
            placeholder={t("enterAlt")}
            label={t("alt")}
            type="text"
            id={`partner-alt-${id}`}
            onChange={onChangeAlt}
            hasError={Boolean(fieldErrors?.["alt"])}
            disabled={readOnly}
          />
        </div>
        <div className={styles.cmsPartnersCardLink}>
          <InnerInput
            value={link}
            placeholder={t("link")}
            label={t("link")}
            type="text"
            id={`partner-link-${id}`}
            onChange={onChangeLink}
            hasError={Boolean(fieldErrors?.["link"])}
            disabled={readOnly}
          />
        </div>
      </div>
      {!readOnly && (
        <button
          className={styles.cmsPartnersCardDelete}
          onClick={onDeleteBannerCard}
        >
          <DeleteIcon />
        </button>
      )}
    </div>
  );
};
